<template>
  <v-container>

    <ViewsContainer
      :moduleName="moduleName"
      :listViewComponent="Table"
      :gridViewComponent="Grid"
      :cardViewComponent="Cards"
      :filterComponent="Filter"
      :data="data"
      :config="'@/components/listing/cars/cars.config'"
      :onCreate="create"
      :onUpdate="update"
      :onDelete="remove"
      :show_toolbar="true"
      :show_pagination="true"
      :title="{singular:'Publicación', plural:'Publicaciones'}"
    />
    
  </v-container>
</template>

<script lang="ts" setup>
import { onMounted, ref, computed } from 'vue';
import { usePreferencesStore } from '@/store/preferences';
import { useCarListingsStore } from '@/store/carListings';
import { useModuleLayoutFetcher } from '@/composables/useModuleLayoutFetcher';
import { HEADERS, DEFAULT_HEADER_ORDER } from '@/components/listing/cars/cars.config';
import { useRoute } from 'vue-router';

import Table from '@/components/views/TableView.vue';
import Grid from '@/components/views/GridView.vue';
import Cards from '@/components/views/CardsView.vue';
import Filter from '@/components/drawer/Filters.vue';
import ViewsContainer from '@/components/views/ViewsContainer.vue'

const route = useRoute();
const moduleName = (route.meta.moduleName ?? route.name) as string;
const preferencesStore = usePreferencesStore();
const carListingsStore = useCarListingsStore();


const {
  create,
  update,
  remove,
} = useModuleLayoutFetcher(
  moduleName,
  (params) => carListingsStore.fetchCarListings(params),
  {
    create: carListingsStore.createCarListing,
    update: (data) => carListingsStore.updateCarListing(data.id, data),
    remove: carListingsStore.deleteCarListing,
  }
);

onMounted(() => {
  preferencesStore.currentModule = moduleName;
  // Registra los headers y defaults para ESTE módulo:
  preferencesStore.setAllModuleHeaders(moduleName, HEADERS);
  preferencesStore.setDefaultModuleHeaders(
    moduleName,
    DEFAULT_HEADER_ORDER
      .map(value => HEADERS.find(header => header.value === value))
      .filter(Boolean) as typeof HEADERS
  );
});

const data = computed(() => carListingsStore.carListings);

</script>
